import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { ACCEPTED_FILE_EXTENSIONS_CASE } from "src/constants";
import { ExcelSheetCaseProps, ExcelSheetHeader, off_therapy, on_therapy, pending_therapy } from "src/pages/patient/types";

export const downloadZipFile = (base64Data: string, fileName: string) => {
  fetch(`data:applicatiaon/x-zip-compressed;base64,${base64Data}`)
    .then(res => res.blob())
    .then((blob) => {
      saveAs(blob, fileName);
    });
};

export const downloadPdfFile = (base64Data: string, fileName: string) => {
  fetch(`data:applicatiaon/pdf;base64,${base64Data}`)
    .then(res => res.blob())
    .then((blob) => {
      saveAs(blob, fileName);
    });
};
export const downloadExcelFile = (base64Data: string, fileName: string) => {
  fetch(`data:applicatiaon/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Data}`)
    .then(res => res.blob())
    .then((blob) => {
      saveAs(blob, fileName);
    });
};

export const downloadFileAccordingToExtension = (base64Data: string, fileName: string) => {
  const fileExtension = `.${fileName.split(".").pop()}`;
  if (fileExtension === ".xlsx") downloadExcelFile(base64Data, fileName);
  else
    fetch(`data:${ACCEPTED_FILE_EXTENSIONS_CASE[fileExtension]};base64,${base64Data}`)
      .then(res => res.blob())
      .then((blob) => {
        saveAs(blob, fileName);
      });
};

export const exportToExcel = (jsonData: ExcelSheetCaseProps[], fileName: string) => {
  // Step 1: Convert JSON to worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');

  const topRow = worksheet.addRow([
    "Patient Name " ,
    "Patient DOB " ,
    "Case ID",
    "Global Patient ID",
    "Case Received",
    "Case Type",
    "Case Completed",
    "Scheduled Treatment Date",
    "Teatment Date Entered",
    "Next Eligible Treatment",
    "Doctor",
    "Address",
    "Doctor City",
    "Doctor State",
    "Doctor Zip",
    "Case Status",
    "Indication",
    "Diagnosis Codes requested",
    "CPT Code",
    "Qty",
    "Primary Insurance",
    "Primary Plan Type",
    "Secondary Insurance",
    "Secondary Plan Type" ,
    "Primary Med Ben Precert Required" ,
    "Primary Pharmacy PA Required" ,
    "Admin code PA required" ,
    "PBM Name" ,
    "Date Transferred to MQC/SP" ,
    "Pharmacy Name" ,
    "External Status Update from Pharmacy" ,
    "Ship Date" ,
    "Tracking Company" ,
    "Tracking Number" ,
    "Outcome" ,
    "Status Reason for Not Treating Patient" ,
  ]);
  topRow.font = { bold: true, size: 14 };
  topRow.alignment = { horizontal: 'center' };

  const parsedJSONData: ExcelSheetCaseProps[] = [];
  jsonData.forEach((kase: off_therapy| on_therapy | pending_therapy | any) => {
    parsedJSONData.push({
      "Patient Name " : kase["patient_name"],
      "Patient DOB ":kase["patient_name"],
      "Case ID":kase["bi_case_id"],
      "Global Patient ID":kase["bi_case_id"],
      "Case Received":kase["bi_case_id"],
      "Case Type":kase["bi_case_id"],
      "Case Completed":kase["bi_completed"],
      "Scheduled Treatment Date":kase["date_of_treatment"],
      "Teatment Date Entered":kase["date_of_treatment"],
      "Next Eligible Treatment":kase["date_of_next_treatment"],
      "Doctor":kase["provider"],
      "Address":kase["provider"],
      "Doctor City":kase["provider"],
      "Doctor State":kase["provider"],
      "Doctor Zip":kase["provider"],
      "Case Status":kase["provider"],
      "Indication":kase["provider"],
      "Diagnosis Codes requested":kase["provider"],
      "CPT Code":kase["provider"],
      "Qty":kase["provider"],
      "Primary Insurance":kase["provider"],
      "Primary Plan Type":kase["provider"],
      "Secondary Insurance":kase["provider"],
      "Secondary Plan Type" :kase["provider"],
      "Primary Med Ben Precert Required" :kase["provider"],
      "Primary Pharmacy PA Required":kase["provider"] ,
      "Admin code PA required" :kase["provider"],
      "PBM Name" :kase["provider"],
      "Date Transferred to MQC/SP" :kase["provider"],
      "Pharmacy Name" :kase["provider"],
      "External Status Update from Pharmacy" :kase["provider"],
      "Ship Date" :kase["provider"],
      "Tracking Company" :kase["provider"],
      "Tracking Number" :kase["provider"],
      "Outcome" :kase["provider"],
      "Status Reason for Not Treating Patient" :kase["provider"],
    })
    worksheet.addRow(Object.values({
      "Patient Name " : kase["patient_name"],
      "Patient DOB ":kase["patient_name"],
      "Case ID":kase["bi_case_id"],
      "Global Patient ID":kase["bi_case_id"],
      "Case Received":kase["bi_case_id"],
      "Case Type":kase["bi_case_id"],
      "Case Completed":kase["bi_completed"],
      "Scheduled Treatment Date":kase["date_of_treatment"],
      "Teatment Date Entered":kase["date_of_treatment"],
      "Next Eligible Treatment":kase["date_of_next_treatment"],
      "Doctor":kase["provider"],
      "Address":kase["provider"],
      "Doctor City":kase["provider"],
      "Doctor State":kase["provider"],
      "Doctor Zip":kase["provider"],
      "Case Status":kase["provider"],
      "Indication":kase["provider"],
      "Diagnosis Codes requested":kase["provider"],
      "CPT Code":kase["provider"],
      "Qty":kase["provider"],
      "Primary Insurance":kase["provider"],
      "Primary Plan Type":kase["provider"],
      "Secondary Insurance":kase["provider"],
      "Secondary Plan Type" :kase["provider"],
      "Primary Med Ben Precert Required" :kase["provider"],
      "Primary Pharmacy PA Required":kase["provider"] ,
      "Admin code PA required" :kase["provider"],
      "PBM Name" :kase["provider"],
      "Date Transferred to MQC/SP" :kase["provider"],
      "Pharmacy Name" :kase["provider"],
      "External Status Update from Pharmacy" :kase["provider"],
      "Ship Date" :kase["provider"],
      "Tracking Company" :kase["provider"],
      "Tracking Number" :kase["provider"],
      "Outcome" :kase["provider"],
      "Status Reason for Not Treating Patient" :kase["provider"],
    }));
  });

  // Set column widths to fit content
  [
   "Patient Name " ,
    "Patient DOB " ,
    "Case ID",
    "Global Patient ID",
    "Case Received",
    "Case Type",
    "Case Completed",
    "Scheduled Treatment Date",
    "Teatment Date Entered",
    "Next Eligible Treatment",
    "Doctor",
    "Address",
    "Doctor City",
    "Doctor State",
    "Doctor Zip",
    "Case Status",
    "Indication",
    "Diagnosis Codes requested",
    "CPT Code",
    "Qty",
    "Primary Insurance",
    "Primary Plan Type",
    "Secondary Insurance",
    "Secondary Plan Type" ,
    "Primary Med Ben Precert Required" ,
    "Primary Pharmacy PA Required" ,
    "Admin code PA required" ,
    "PBM Name" ,
    "Date Transferred to MQC/SP" ,
    "Pharmacy Name" ,
    "External Status Update from Pharmacy" ,
    "Ship Date" ,
    "Tracking Company" ,
    "Tracking Number" ,
    "Outcome" ,
    "Status Reason for Not Treating Patient" ,
  ].forEach((header: string, i: number) => {
    const maxLength = Math.max(
      header.length,
      ...parsedJSONData.map((item: ExcelSheetCaseProps) => String(item[header as ExcelSheetHeader] || '').length)
    );
    worksheet.getColumn(i + 1).width = maxLength + 5; // +2 for padding
    worksheet.getColumn(i + 1).alignment = { horizontal: 'center' };
  });

  workbook.xlsx.writeBuffer().then((buffer: any) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
  
    saveAs(blob, fileName);
  });
};